import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";

@Injectable()
export class ExamineeInternalForm {
  constructor(private fb: FormBuilder) {}

  build(): FormGroup {
    return this.fb.group(
      {
        StudentId: [""],
        ACTId: [""],
        EXTPersonId: [""],
        personId: [""],
        FirstName: ["", [Validators.required]],
        MiddleName: [""],
        personAddressID: [""],
        personNameID: [""],
        LastName: ["", [Validators.required]],
        DOB: ["", [Validators.required]],
        Country: ["", [Validators.required]],
        Address1: ["", [Validators.required]],
        Address2: [""],
        InternationalZip: [""],
        InternationalCity: ["", [Validators.required]],
        NationalZip: [""],
        NationalState: [""],
        NationalCity: [""]
      },
      {
        validator: formControl => {
          const sid = formControl.controls
            ? formControl.controls.StudentId
            : undefined;
          const aid = formControl.controls
            ? formControl.controls.ACTId
            : undefined;
          const pid = formControl.controls
            ? formControl.controls.EXTPersonId
            : undefined;
          const fName = formControl.controls
            ? formControl.controls.FirstName
            : undefined;
          const mName = formControl.controls
            ? formControl.controls.MiddleName
            : undefined;
          const lName = formControl.controls
            ? formControl.controls.LastName
            : undefined;
          const dob = formControl.controls
            ? formControl.controls.DOB
            : undefined;
          const addr1 = formControl.controls
            ? formControl.controls.Address1
            : undefined;
          const addr2 = formControl.controls
            ? formControl.controls.Address2
            : undefined;
          const intlZip = formControl.controls
            ? formControl.controls.InternationalZip
            : undefined;
          const intlCity = formControl.controls
            ? formControl.controls.InternationalCity
            : undefined;

          if (sid !== undefined || aid !== undefined || pid !== undefined) {
            if (
              !(
                (sid.value && sid.value.length) ||
                (aid.value && aid.value.length) ||
                (pid.value && pid.value.length)
              )
            ) {
              return { actOrSidRequired: true };
            }
          }

          if (sid.value) {
            const submitStudentId = sid.value.replace(/-/gi, "");
            const pattern = /[a-z A-Z 0-9]$/;
            const regex = new RegExp(pattern);
            if (
              submitStudentId.length > 20 ||
              regex.test(submitStudentId) === false
            ) {
              return { pattern: true };
            }
          }

          if (aid.value) {
            const submitActID = aid.value.replace(/-/gi, "");
            const pattern = /[0-9]{8,9}$/;
            const regex = new RegExp(pattern);
            if (
              !(submitActID.length === 8 || submitActID.length === 9) ||
              regex.test(submitActID) === false
            ) {
              return { invalidActIdPattern: true };
            }
          }

          if (pid.value) {
            const submittedPersonID = pid.value.replace(/-/gi, "");
            const pattern = /[0-9]{8,9}$/;
            const regex = new RegExp(pattern);
            if (
              !(submittedPersonID.length === 9) ||
              regex.test(submittedPersonID) === false
            ) {
              return { invalidPersonIdPattern: true };
            }
          }


          if (fName.value) {
            const submitFName = fName.value.replace(/-/gi, "");
            const pattern = /[a-z A-Z ' -]$/;
            const regex = new RegExp(pattern);
            if (submitFName.length > 50 || regex.test(submitFName) === false) {
              return { invalidfNamePattern: true };
            }
          }

          if (mName.value) {
            const submitMName = mName.value.replace(/-/gi, "");
            const pattern = /[a-z A-Z]$/;
            const regex = new RegExp(pattern);
            if (submitMName.length > 1 || regex.test(submitMName) === false) {
              return { invalidmNamePattern: true };
            }
          }

          if (lName.value) {
            const submitLName = lName.value.replace(/-/gi, "");
            const pattern = /[a-z A-Z ' -]$/;
            const regex = new RegExp(pattern);
            if (submitLName.length > 50 || regex.test(submitLName) === false) {
              return { invalidlNamePattern: true };
            }
          }

          if (dob !== undefined && dob.value) {
            if (typeof dob.value === "string") {
              dob.value = new Date(dob.value);
            }
            const age = moment().diff(moment(dob.value), 'years');
            if (age >= 60 || age < 0) {
              return { minDob: true };
            }

            dob.value = moment(dob.value).format("MM/DD/YYYY");
          }

          if (addr1.value || addr2.value) {
            const submitAddr1 = addr1.value;
            const submitAddr2 = addr2.value;
            const pattern = /[a-z A-Z 0-9  - , # \ . +]$/;
            const regex = new RegExp(pattern);
            if (
              submitAddr1.length === 0 ||
              submitAddr1.length > 100 ||
              regex.test(submitAddr1) === false ||
              submitAddr2.length > 100
            ) {
              return { invalidAddrPattern: true };
            }
            if (submitAddr2.length !== 0) {
              if (regex.test(submitAddr2) === false) {
                return { invalidAddrPattern: true };
              }
            }
          }

          if (intlZip.value) {
            const submitIntlZip = intlZip.value;
            const pattern = /[a-z A-Z 0-9   -]$/;
            const regex = new RegExp(pattern);
            if (
              submitIntlZip.length > 20 ||
              regex.test(submitIntlZip) === false
            ) {
              return { invalidIntlZipPattern: true };
            }
          }

          if (intlCity.value) {
            const submitIntlCity = intlCity.value;
            const pattern = /[a-z A-Z ,  .]$/;
            const regex = new RegExp(pattern);
            if (
              submitIntlCity.length > 20 ||
              regex.test(submitIntlCity) === false
            ) {
              return { invalidIntlCityPattern: true };
            }
          }

          return null;
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/edit-examinee/examinee.form.ts